import { c as _c } from "react/compiler-runtime";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { useIsVisible } from "@website/hooks/is-visible";
import { MaterialIcon } from "@website/icons/material";
import { ReserveCommentAvatar } from "@website/widget/reserve-comment/reserve-comment-avavtar";
import { ReserveCommentHeader } from "@website/widget/reserve-comment/reserve-comment-header";
import { ReserveCommentPictures } from "@website/widget/reserve-comment/reserve-comment-pictures";
import { ReserveCommentPoints } from "@website/widget/reserve-comment/reserve-comment-points";
import { ReserveCommentPropertiesType } from "@website/widget/reserve-comment/reserve-comment.types";
import { ImageType } from "@website/widget/reserve-gallery/reserve-gallery.types";
import { useEffect } from "react";
export const ReserveComment = properties => {
  const $ = _c(60);
  const {
    id,
    roomId,
    createdAt,
    userName,
    roomName,
    rate,
    registeredDate,
    standNights,
    comment,
    strengths,
    weakness,
    source,
    pictures,
    helpfulSubmitted,
    onUsefulnessClick,
    submitSucceed,
    onVisibleComment
  } = properties;
  const t0 = pictures as Array<ImageType>;
  let t1;
  if ($[0] !== id || $[1] !== registeredDate || $[2] !== roomName || $[3] !== standNights || $[4] !== t0) {
    t1 = {
      id,
      roomName,
      standNights,
      registeredDate,
      gallery: t0
    };
    $[0] = id;
    $[1] = registeredDate;
    $[2] = roomName;
    $[3] = standNights;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const commentPicturesProperties = t1;
  const {
    reference,
    inView
  } = useIsVisible();
  const {
    isLoggedIn
  } = useLoginStatus();
  let t2;
  let t3;
  if ($[6] !== comment || $[7] !== createdAt || $[8] !== id || $[9] !== inView || $[10] !== onVisibleComment || $[11] !== pictures || $[12] !== roomId) {
    t2 = () => {
      onVisibleComment?.({
        id,
        comment,
        pictures,
        roomId,
        createdAt,
        inView
      });
    };
    t3 = [comment, createdAt, id, inView, onVisibleComment, pictures, roomId];
    $[6] = comment;
    $[7] = createdAt;
    $[8] = id;
    $[9] = inView;
    $[10] = onVisibleComment;
    $[11] = pictures;
    $[12] = roomId;
    $[13] = t2;
    $[14] = t3;
  } else {
    t2 = $[13];
    t3 = $[14];
  }
  useEffect(t2, t3);
  const t4 = source === "booking.com" ? "ltr" : "rtl";
  let t5;
  if ($[15] !== rate) {
    t5 = <div className="hidden shrink pe-2 before:hidden before:size-[48px] before:rounded-full before:border before:content-[''] xl:block before:xl:inline-block"><ReserveCommentAvatar className="mx-auto mt-[-48px] size-auto" rate={rate} /></div>;
    $[15] = rate;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== rate || $[18] !== registeredDate || $[19] !== roomName || $[20] !== source || $[21] !== standNights || $[22] !== userName) {
    t6 = <ReserveCommentHeader properties={{
      userName,
      roomName,
      registeredDate,
      standNights,
      source,
      rate
    }} />;
    $[17] = rate;
    $[18] = registeredDate;
    $[19] = roomName;
    $[20] = source;
    $[21] = standNights;
    $[22] = userName;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== comment) {
    t7 = comment && <div className="text-caption xl:text-body-2">{comment}</div>;
    $[24] = comment;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t6 || $[27] !== t7) {
    t8 = <div className="flex grow flex-col gap-4">{t6}{t7}</div>;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t5 || $[30] !== t8) {
    t9 = <div className="flex flex-row">{t5}{t8}</div>;
    $[29] = t5;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== strengths) {
    t10 = strengths && <ReserveCommentPoints properties={{
      message: strengths,
      type: "strengths"
    }} />;
    $[32] = strengths;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== weakness) {
    t11 = weakness && <ReserveCommentPoints properties={{
      message: weakness,
      type: "weakness"
    }} />;
    $[34] = weakness;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t10 || $[37] !== t11) {
    t12 = <div className="flex flex-col gap-3">{t10}{t11}</div>;
    $[36] = t10;
    $[37] = t11;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== comment || $[40] !== strengths || $[41] !== weakness) {
    t13 = !comment && !strengths && !weakness && <div className="text-caption xl:text-body-2 text-on-surface-medium-emphasis">این کاربر صرفا امتیاز خود را ثبت کرده است.</div>;
    $[39] = comment;
    $[40] = strengths;
    $[41] = weakness;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== commentPicturesProperties || $[44] !== pictures) {
    t14 = pictures && pictures?.length > 0 && <div><ReserveCommentPictures {...commentPicturesProperties} /></div>;
    $[43] = commentPicturesProperties;
    $[44] = pictures;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== helpfulSubmitted || $[47] !== id || $[48] !== isLoggedIn || $[49] !== onUsefulnessClick || $[50] !== submitSucceed) {
    t15 = onUsefulnessClick && isLoggedIn && <div className={`${!helpfulSubmitted && !submitSucceed ? "opacity-100" : "opacity-0"} text-caption text-on-surface-high-emphasis cursor-pointer self-end`} onClick={() => onUsefulnessClick ? onUsefulnessClick(id) : null}><span>این دیدگاه مفید بود؟</span><MaterialIcon className="text-on-surface-high-emphasis mx-1" name="check_circle" variant="outlined" /></div>;
    $[46] = helpfulSubmitted;
    $[47] = id;
    $[48] = isLoggedIn;
    $[49] = onUsefulnessClick;
    $[50] = submitSucceed;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  let t16;
  if ($[52] !== reference || $[53] !== t12 || $[54] !== t13 || $[55] !== t14 || $[56] !== t15 || $[57] !== t4 || $[58] !== t9) {
    t16 = <div className="shadow-1 bg-dim-background flex w-full flex-col gap-4 overflow-hidden rounded-xl p-4 xl:p-6" dir={t4} ref={reference}>{t9}{t12}{t13}{t14}{t15}</div>;
    $[52] = reference;
    $[53] = t12;
    $[54] = t13;
    $[55] = t14;
    $[56] = t15;
    $[57] = t4;
    $[58] = t9;
    $[59] = t16;
  } else {
    t16 = $[59];
  }
  return t16;
};